export {
  TEMPLATE_ASSET_UUIDS,
  TEMPLATE_UUID_TO_KEY,
  getTemplateAssetCdnUrl,
  collectImageUuids,
  isTemplateAsset,
  getTemplateCategory,
  getFeaturedTemplates,
  getTemplatesByCategory,
  getTemplatesForMode,
} from "./utils";

export { TEMPLATE_REGISTRY } from "./registry";

export type {
  ComposeTemplate,
  DetectExamplePrefill,
  DetectTemplate,
  TemplateAsset,
  TemplateBase,
  TemplateCategory,
  TemplateDefinition,
  TemplateRegistry,
} from "./types";
